import React from "react";
import logo from "../../assets/images/logo.svg";
import './styles.css'

export const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
      <div className="row">
            <div className="footer-left-side">
              <div className="footer-logo">
                <img  alt="logo" src={logo} />
                <a href="#">Courses Store</a>
                <p className="footer-paragraph">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam
                  mollis, justo nec porttitor auctor, erat sapien faucibus
                  lectus, vel tempor dolor augue et lectus.
                </p>
                <div className="icons">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="3"
                    height="7"
                    viewBox="0 0 3 7"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_148)">
                      <path
                        d="M0.806586 6.6917V3.9861H0.0706177V3.01196H0.806586V2.17992C0.806586 1.52609 1.24132 0.925659 2.24306 0.925659C2.64864 0.925659 2.94855 0.963456 2.94855 0.963456L2.92492 1.87314C2.92492 1.87314 2.61906 1.87025 2.28529 1.87025C1.92405 1.87025 1.86617 2.03207 1.86617 2.30066V3.01196H2.95364L2.90632 3.9861H1.86617V6.6917H0.806586Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_148">
                        <rect
                          width="2.88302"
                          height="5.76604"
                          fill="white"
                          transform="translate(0.0705872 0.925903)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="7"
                    viewBox="0 0 9 7"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_153)">
                      <path
                        d="M8.10317 1.62818C7.82848 1.74535 7.53713 1.82225 7.23879 1.85634C7.54954 1.67702 7.78815 1.39305 7.9005 1.0547C7.60509 1.22348 7.28189 1.3424 6.94486 1.40632C6.67032 1.12472 6.27922 0.94873 5.84635 0.94873C5.01521 0.94873 4.34135 1.59751 4.34135 2.39769C4.34135 2.51127 4.35467 2.62185 4.38032 2.72792C3.12957 2.66748 2.02066 2.09063 1.27837 1.21397C1.14886 1.42797 1.07464 1.67691 1.07464 1.94242C1.07464 2.44514 1.34035 2.88863 1.74415 3.14849C1.50516 3.14128 1.27143 3.07913 1.06247 2.96723C1.06238 2.9733 1.06238 2.97937 1.06238 2.98546C1.06238 3.68751 1.58113 4.27317 2.26958 4.40628C2.04796 4.46431 1.8155 4.4728 1.58996 4.43111C1.78145 5.00678 2.33726 5.42568 2.99578 5.43741C2.48073 5.82602 1.8318 6.05768 1.12674 6.05768C1.00524 6.05768 0.88547 6.05082 0.767731 6.03743C1.43374 6.44856 2.22479 6.68844 3.07467 6.68844C5.84285 6.68844 7.35656 4.4805 7.35656 2.56573C7.35656 2.50288 7.35513 2.4404 7.3522 2.37827C7.64683 2.17319 7.90113 1.91919 8.10317 1.62818Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_153">
                        <rect
                          width="7.41348"
                          height="5.76604"
                          fill="white"
                          transform="translate(0.780685 0.925903)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="7"
                    viewBox="0 0 8 7"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_158)">
                      <path
                        d="M2.42491 6.69157V2.52335H1.02698V6.69157H2.42491ZM1.72613 1.95391C2.21361 1.95391 2.51705 1.63384 2.51705 1.23386C2.50796 0.824859 2.21363 0.513672 1.73538 0.513672C1.2572 0.513672 0.944504 0.824865 0.944504 1.23386C0.944504 1.63386 1.24786 1.95391 1.717 1.95391H1.72608H1.72613ZM3.19866 6.69157H4.5966V4.36384C4.5966 4.23926 4.60568 4.11481 4.64259 4.02576C4.74365 3.77686 4.97367 3.51906 5.35984 3.51906C5.86569 3.51906 6.06806 3.9013 6.06806 4.46164V6.69154H7.4659V4.30153C7.4659 3.02121 6.77624 2.4255 5.85648 2.4255C5.10236 2.4255 4.77124 2.84326 4.58729 3.12779H4.59663V2.52327H3.19869C3.21704 2.91439 3.19869 6.69149 3.19869 6.69149L3.19866 6.69157Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_158">
                        <rect
                          width="6.58976"
                          height="6.1779"
                          fill="white"
                          transform="translate(0.961761 0.513916)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_163)">
                      <path
                        d="M3.97528 2.14366C3.04962 2.14366 2.30298 2.88645 2.30298 3.80735C2.30298 4.72824 3.04962 5.47103 3.97528 5.47103C4.90094 5.47103 5.64758 4.72824 5.64758 3.80735C5.64758 2.88645 4.90094 2.14366 3.97528 2.14366ZM3.97528 4.88896C3.37709 4.88896 2.88806 4.4039 2.88806 3.80735C2.88806 3.21079 3.37564 2.72573 3.97528 2.72573C4.57492 2.72573 5.0625 3.21079 5.0625 3.80735C5.0625 4.4039 4.57347 4.88896 3.97528 4.88896ZM6.10605 2.07561C6.10605 2.29135 5.9314 2.46365 5.71599 2.46365C5.49913 2.46365 5.32593 2.2899 5.32593 2.07561C5.32593 1.86131 5.50058 1.68756 5.71599 1.68756C5.9314 1.68756 6.10605 1.86131 6.10605 2.07561ZM7.21364 2.46945C7.1889 1.94963 7.06955 1.48919 6.68677 1.10983C6.30544 0.730466 5.84261 0.611734 5.32011 0.585671C4.7816 0.555265 3.16751 0.555265 2.62899 0.585671C2.10795 0.610286 1.64512 0.729018 1.26233 1.10838C0.879552 1.48774 0.761661 1.94819 0.735463 2.468C0.704899 3.00374 0.704899 4.60951 0.735463 5.14525C0.760205 5.66506 0.879552 6.1255 1.26233 6.50486C1.64512 6.88423 2.10649 7.00296 2.62899 7.02902C3.16751 7.05943 4.7816 7.05943 5.32011 7.02902C5.84261 7.00441 6.30544 6.88567 6.68677 6.50486C7.0681 6.1255 7.18744 5.66506 7.21364 5.14525C7.24421 4.60951 7.24421 3.00519 7.21364 2.46945ZM6.51794 5.72008C6.40441 6.00388 6.18464 6.22252 5.89792 6.3369C5.46856 6.50631 4.44975 6.46722 3.97528 6.46722C3.50081 6.46722 2.48054 6.50486 2.05264 6.3369C1.76737 6.22396 1.5476 6.00532 1.43262 5.72008C1.26233 5.29294 1.30163 4.27938 1.30163 3.80735C1.30163 3.33532 1.26379 2.32031 1.43262 1.89461C1.54614 1.61082 1.76592 1.39218 2.05264 1.27779C2.48199 1.10838 3.50081 1.14747 3.97528 1.14747C4.44975 1.14747 5.47002 1.10983 5.89792 1.27779C6.18319 1.39073 6.40296 1.60937 6.51794 1.89461C6.68823 2.32176 6.64893 3.33532 6.64893 3.80735C6.64893 4.27938 6.68823 5.29438 6.51794 5.72008Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_163">
                        <rect
                          width="6.58976"
                          height="7.41348"
                          fill="white"
                          transform="translate(0.731049 0.101807)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
            <div className="footer-right-side">
                <div className="footer-item">
                    <h2 className="footer-title">Home</h2>
                    <nav>
                        <a href ="#">Product</a>
                        <a href ="#">Course</a>
                        <a href ="#">About</a>
                        <a href ="#">Login</a>
                        </nav>
                </div>
                <div className="footer-item">
                    <h2 className="footer-title">Course</h2>
                    <nav>
                        <a href ="#">HTML & CSS</a>
                        <a href ="#">Javascript</a>
                        <a href ="#">Photographer</a>
                        <a href ="#">Design Graphic</a>
                        </nav>
                </div>
                <div className="footer-item">
                    <h2 className="footer-title" >Article</h2>
                    <nav>
                        <a href ="#">New</a>
                        <a href ="#">Old</a>
                        <a href ="#">Trend</a>
                        <a href ="#">Popular</a>
                        </nav>
                </div>
                <div className="footer-item">
                    <h2 className="footer-title">Contact</h2>
                    <nav>
                        <a href ="#">CCdoc123@gmail.com</a>
        
                        </nav>
                </div>

            </div>
          </div>      </div>
    </div>
  );
};

